import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/dashboard';

export default {
    getOnboardingStep() {
        return axios.get(`${RESOURCE_NAME}/get-onboarding-step`);
    },

    saveOnboardingStep(step) {
        return axios.post(`${RESOURCE_NAME}/save-onboarding-step`, {step});
    },

    getNeedsNumbers() {
        return axios.get(`${RESOURCE_NAME}/get-needs-numbers`);
    },

    getNeedsSolutionsNumbers() {
        return axios.get(`${RESOURCE_NAME}/get-needs-solutions-numbers`);
    },

    getActivities() {
        return axios.get(`${RESOURCE_NAME}/get-activities`);
    },

    getNeedsListTypes() {
        return axios.get(`${RESOURCE_NAME}/get-needs-list-types`);
    },

    getNeedsList(type, filters) {
        return axios.post(`${RESOURCE_NAME}/get-needs-list?type=${type}`, {filters});
    },

    getNeedsCategories(type, filters) {
        return axios.post(`${RESOURCE_NAME}/get-needs-categories?type=${type}`, {filters});
    },

    getSubmittedStartupsList(filters) {
        return axios.post(`${RESOURCE_NAME}/get-submitted-startups-list`, {filters});
    },
}
